/* ================================================================
   Hope Estate — Enhancements JS
   - Open/closed indicator
   - Beer counter animation
   - Club savings calculator
   - Scroll reveal for custom sections
   - Sticky cellar door booking bar
   - Card entrance stagger
================================================================ */
(function () {
  'use strict';

  /* ── 1. OPEN/CLOSED INDICATOR ─────────────────────────────── */
  var HOURS = {
    // 0=Sun,1=Mon...6=Sat  [open24h,openH,openM,closeH,closeM]
    0: [false, 10, 0, 16, 0],  // Sun 10-4
    1: null,                    // Mon closed
    2: null,                    // Tue closed
    3: [false, 10, 0, 17, 0],  // Wed 10-5
    4: [false, 10, 0, 17, 0],  // Thu
    5: [false, 10, 0, 17, 0],  // Fri
    6: [false, 10, 0, 17, 0],  // Sat
  };

  function getSydneyTime() {
    // Force Sydney AEST/AEDT regardless of visitor's local timezone
    var now = new Date();
    var sydneyStr = now.toLocaleString('en-AU', { timeZone: 'Australia/Sydney' });
    // Parse: day/month/year, hour:min:sec am/pm
    var parts = sydneyStr.match(/(\d+)\/(\d+)\/(\d+),?\s+(\d+):(\d+):(\d+)\s*(am|pm)?/i);
    if (!parts) return now; // fallback
    var h = parseInt(parts[4], 10);
    var m = parseInt(parts[5], 10);
    var ampm = parts[7] ? parts[7].toLowerCase() : null;
    if (ampm === 'pm' && h !== 12) h += 12;
    if (ampm === 'am' && h === 12) h = 0;
    // Get day of week in Sydney
    var sydDate = new Date(now.toLocaleString('en-US', { timeZone: 'Australia/Sydney' }));
    return { day: sydDate.getDay(), hours: h, minutes: m };
  }

  function isOpen() {
    var syd = getSydneyTime();
    var h = HOURS[syd.day];
    if (!h) return false;
    var mins = syd.hours * 60 + syd.minutes;
    var open = h[1] * 60 + h[2];
    var close = h[3] * 60 + h[4];
    return mins >= open && mins < close;
  }

  function updateOpenIndicators() {
    var open = isOpen();
    var status = open ? 'open' : 'closed';
    var label = open ? 'Open now' : 'Closed';
    document.querySelectorAll('[data-he-open-dot]').forEach(function (el) {
      el.setAttribute('data-status', status);
      el.title = label;
    });
    document.querySelectorAll('[data-he-open-label]').forEach(function (el) {
      el.textContent = label;
      el.setAttribute('data-status', status);
    });
    // Highlight today's hours row
    var day = new Date().getDay();
    var names = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
    document.querySelectorAll('[data-he-day]').forEach(function(row) {
      var rowDay = row.getAttribute('data-he-day');
      if (rowDay === names[day]) {
        row.classList.add('he-hours-today');
        if (open) row.classList.add('he-hours-open');
      }
    });
  }

  /* ── 2. COUNTER ANIMATION ─────────────────────────────────── */
  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-he-count'), 10);
    var duration = 1600;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(ease * target);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ── 3. CLUB SAVINGS CALCULATOR ──────────────────────────── */
  function initSavingsCalc() {
    var calc = document.getElementById('he-savings-calc');
    if (!calc) return;

    var slider = calc.querySelector('#he-calc-bottles');
    var typeEl = calc.querySelector('#he-calc-type');
    var display = calc.querySelector('#he-calc-result');

    var PRICES = {
      wine: 25,    // avg bottle price
      beer: 7,     // avg per bottle (case of 24 ~ $168)
      spirits: 65  // avg bottle
    };
    var TIERS = [
      { name: 'Silver', pct: 0.10, label: 'silver' },
      { name: 'Gold',   pct: 0.25, label: 'gold' },
      { name: 'Platinum', pct: 0.30, label: 'platinum' }
    ];

    function update() {
      var qty = parseInt(slider.value, 10);
      var type = typeEl.value;
      var price = PRICES[type] || 25;
      var spend = qty * price;

      var html = '<div class="hcc-result__spend">Estimated annual spend: <strong>$' + spend.toLocaleString() + '</strong></div>';
      html += '<div class="hcc-result__tiers">';
      TIERS.forEach(function(tier) {
        var saving = Math.round(spend * tier.pct);
        html += '<div class="hcc-result__tier hcc-result__tier--' + tier.label + '">' +
          '<span class="hcc-result__tier-name">' + tier.name + '</span>' +
          '<span class="hcc-result__tier-saving">Save <strong>$' + saving.toLocaleString() + '</strong>/yr</span>' +
          '</div>';
      });
      html += '</div>';
      html += '<p class="hcc-result__note">Based on ' + qty + ' ' + (type === 'beer' ? 'cans/bottles' : 'bottles') + ' of ' + type + ' at ~$' + price + ' avg. Actual savings may vary.</p>';
      display.innerHTML = html;

      // Update slider label
      var label = calc.querySelector('#he-calc-qty-label');
      if (label) label.textContent = qty + ' ' + (type === 'beer' ? 'cans/bottles' : 'bottles') + '/year';
    }

    slider && slider.addEventListener('input', update);
    typeEl && typeEl.addEventListener('change', update);
    update();
  }

  /* ── 4. SCROLL REVEAL FOR CUSTOM SECTIONS ────────────────── */
  function initScrollReveal() {
    if (!window.IntersectionObserver) return;
    var els = document.querySelectorAll(
      '.hcd-tasting-card, .hcd-offer-card, .hcd-sidebar__card, ' +
      '.hc-tier, .hc-case, ' +
      '.hfn-venue-card, ' +
      '.hsl-mm-tile, .hsl-divider__item, ' +
      '.hch-mm__opt, ' +
      '.hmm-pack, ' +
      '.hf-hours-row'
    );
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('he-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function(el, i) {
      el.classList.add('he-reveal');
      el.style.transitionDelay = (i % 4 * 0.08) + 's';
      obs.observe(el);
    });
  }

  /* ── 5. STICKY CELLAR DOOR BOOKING BAR ───────────────────── */
  function initStickyBooking() {
    var bar = document.getElementById('he-sticky-book');
    if (!bar) return;
    var widget = document.querySelector('.hcd-booking-cta');
    if (!widget) return;

    function update() {
      var rect = widget.getBoundingClientRect();
      var visible = rect.top < window.innerHeight && rect.bottom > 0;
      bar.classList.toggle('he-sticky-book--visible', !visible);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── 6. CARD STAGGER ENTRANCE ────────────────────────────── */
  function initCardStagger() {
    if (!window.IntersectionObserver) return;
    document.querySelectorAll('.product-grid, .hsl-products').forEach(function(grid) {
      var cards = Array.from(grid.querySelectorAll('.card-wrapper, .hsl-product'));
      if (!cards.length) return;
      cards.forEach(function(card) { card.classList.add('he-card-stagger'); });
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          var gridCards = Array.from(entry.target.querySelectorAll('.he-card-stagger'));
          gridCards.forEach(function(card, i) {
            setTimeout(function() {
              card.classList.add('he-card-stagger--in');
            }, i * 60);
          });
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.05 });
      obs.observe(grid);
    });
  }

  /* ── 7. COUNTER OBSERVER ─────────────────────────────────── */
  function initCounters() {
    if (!window.IntersectionObserver) return;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-he-count]').forEach(function(el) {
      obs.observe(el);
    });
  }

  /* ── INIT ─────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    updateOpenIndicators();
    initSavingsCalc();
    initScrollReveal();
    initStickyBooking();
    initCardStagger();
    initCounters();
  });
})();
